import React from "react";
import "./mobileMenu.scss";
import { useState } from "react";

const MobileMenu = ({ openMenu, setOpenMenu }) => {
    return (
        <div className="hamburger-lines" onClick={() => setOpenMenu(!openMenu)}>
            <span className={openMenu ? "line line1 line1-active" : "line line1"}></span>
            <span className={openMenu ? "line line2 line2-active" : "line line2"}></span>
            <span className={openMenu ? "line line3 line3-active" : "line line3"}></span>
        </div>
    );
};

export default MobileMenu;
